export default "__VITE_ASSET__C1jLh$9z__"